import { render, staticRenderFns } from "./inputFeedback.vue?vue&type=template&id=2ffad8b6&scoped=true&"
import script from "./inputFeedback.vue?vue&type=script&lang=js&"
export * from "./inputFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffad8b6",
  null
  
)

export default component.exports